import React from 'react'
import './SingleType.css'

function SingleType() {
  return (
    <div className="programme">
    <img src="./img/programmes-icon.png" alt="" />
    <div className="programmeContent">
      <h3>Cultural Programmes</h3>
      <p>5 programmes</p>
    </div>
  </div>  )
}

export default SingleType